import Joi from 'joi';

export const allowanceSchema = Joi.object({
  allowanceName: Joi.string()
    .min(2)
    .max(100)
    .required()
    .messages({
      "string.empty": "Allowance name is required.",
      "string.min": "Allowance name must be at least 2 characters.",
      "string.max": "Allowance name must not exceed 100 characters.",
      "any.required": "Allowance name is required.",
    }),
  allowanceType: Joi.string()
    .valid("percentage", "fixed") // Assuming these are the valid types
    .required()
    .messages({
      "string.empty": "Allowance type is required.",
      "any.invalid": "Allowance type is required.",

      "any.only": "Allowance type must be either 'Percentage' or 'Fixed'.",
      "any.required": "Allowance type is required.",
    }),
    allowanceValue: Joi.number()
    .custom((value, helpers) => {
      const { allowanceType } = helpers?.prefs?.context || {};

      // Validate based on allowanceType
      if (allowanceType === "percentage") {
        if (value < 1 || value > 100) {
          return helpers.error("any.custom", { message: "For 'Percentage' allowance type, value must be between 1 and 100." });
        }
      } else if (allowanceType === "fixed") {
        if (value < 1) {
          return helpers.error("any.custom", { message: "For 'Fixed' allowance type, value must be at least 1." });
        }
      }

      return value; // Valid value
    })
    .required()
    .messages({
      "number.base": "Value must be a number.",
      "any.required": "Value is required.",
      "any.custom": "{{#message}}",
    }),
 
  noWorkNoPay: Joi.boolean()
    .required()
    .messages({
      "any.required": "Pay for is required.",
      "any.invalid": "Pay for Pay is required.",
      "boolean.base": "Pay for Pay is required.",

    }),
  isEsiWages: Joi.boolean()
    .required()
    .messages({
      "any.required": "ESI Wages field is required.",
    }),
  isEpfWages: Joi.boolean()
    .required()
    .messages({
      "any.required": "EPF Wages field is required.",
    }),
  status: Joi.boolean()
    .required()
    .messages({
      "any.required": "Status field is required.",
    }),
});
